<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data VesselType" subTitle="Forms" />

    <CreateVesselType />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateVesselType from "@/components/Pages/Master/VesselType/CreateVesselType.vue";

export default defineComponent({
  name: "CreateVesselTypePage",
  components: {
    PageTitle,
    CreateVesselType,
  },
});
</script>
